import React from 'react';
import ProductRoute from './ProductRoute';
import CategoryRoute from './CategoryRoute';
import ContentRoute from './ContentRoute';
import Status from './Status';
import { Redirect } from 'react-router';
import { setPageType } from '../../analytics/webVitals';
import { DefaultError } from '@jetshop/ui/ErrorBoundary/Generic';
const isRouteType = (state, result, type) => {
    var _a, _b, _c;
    if (result.error) {
        return false;
    }
    const stateType = state === null || state === void 0 ? void 0 : state.type;
    const routeType = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) === null || _c === void 0 ? void 0 : _c.__typename;
    const emptyRoute = !result.loading && !routeType;
    if (emptyRoute) {
        return false;
    }
    else {
        return stateType === type || routeType === type;
    }
};
const isEmptyRoute = (result) => {
    var _a, _b, _c, _d, _e, _f;
    const errorCode = (_e = (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.error) === null || _a === void 0 ? void 0 : _a.graphQLErrors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.extensions) === null || _d === void 0 ? void 0 : _d.code) !== null && _e !== void 0 ? _e : '';
    const route = (_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.route;
    return (errorCode.includes('EmptyRoute') ||
        !route ||
        (typeof window !== 'undefined' && window.__STATUS_CODE__ === '404'));
};
const Loading = (LoadingPage) => LoadingPage ? React.createElement(LoadingPage, null) : React.createElement("div", null, "Loading...");
const RouteResolver = ({ productPage, categoryPage, contentPage, notFoundPage: NotFoundPage, ErrorPage, LoadingPage, result, pathname, state, search }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    setPageType((_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.route) === null || _b === void 0 ? void 0 : _b.object) === null || _c === void 0 ? void 0 : _c.__typename);
    if (((_f = (_e = (_d = result === null || result === void 0 ? void 0 : result.data) === null || _d === void 0 ? void 0 : _d.route) === null || _e === void 0 ? void 0 : _e.path) !== null && _f !== void 0 ? _f : pathname) !== pathname) {
        return (React.createElement(Status, { code: 301 },
            React.createElement(Redirect, { to: {
                    pathname: result.data.route.path,
                    state: Object.assign(Object.assign({}, state), { type: (_j = (_h = (_g = result === null || result === void 0 ? void 0 : result.data) === null || _g === void 0 ? void 0 : _g.route) === null || _h === void 0 ? void 0 : _h.object) === null || _j === void 0 ? void 0 : _j.__typename }),
                    search
                } })));
    }
    else if (isRouteType(state, result, 'Product')) {
        return (React.createElement(ProductRoute, { result: result, partialProduct: state === null || state === void 0 ? void 0 : state.product, component: productPage }));
    }
    else if (isRouteType(state, result, 'Category')) {
        return React.createElement(CategoryRoute, { result: result, component: categoryPage });
    }
    else if (isRouteType(state, result, 'Page')) {
        return (React.createElement(ContentRoute, { pathname: pathname, result: result, component: contentPage }));
    }
    else if (result.loading) {
        return Loading(LoadingPage);
    }
    else {
        if (isEmptyRoute(result)) {
            return (React.createElement(Status, { code: 404 },
                React.createElement(NotFoundPage, null)));
        }
        return (React.createElement(Status, { code: 500, error: result.error }, ErrorPage ? (React.createElement(ErrorPage, { error: result.error })) : (React.createElement(DefaultError, { error: result.error }))));
    }
};
export default RouteResolver;
//# sourceMappingURL=RouteResolver.js.map